<template>
  <div class="detail">
    <Loading></Loading>
    <div class="wrap detail-wrap">

      <div class="wrap-inner">
        <!--poster start-->
        <!--poster end-->
        <div class="content-inner-box">
          <!--header start-->
          <!--
          <div class="header detail-header">
            <a v-if="detailsTxte.page_config && detailsTxte.page_config.independent_index &&detailsTxte.page_config.independent_index.is_show ==1" :href="detailsTxte.page_config.independent_index.url" class="f-l">
              <i class="icon-logo"></i>
            </a>
            <a v-else href="javascript:void(0);" class="f-l">
              <router-link to="/home" tag="i" class="icon-logo"></router-link>
            </a>
            <span>
              <img :src="globalUrl + 'static/dist/img/sds.png'" alt=""/>
            </span>
            <a href="javascript:void(0)" class="f-r">
              <router-link to="/find" tag="i" class="icon-menu"></router-link>
            </a>
          </div>
          -->
          <!--header end-->
          <div class="detai-pic" v-if="detailsTxte.playbill_vertical">
            <img :src="detailsTxte.playbill_vertical" alt="" style="width:100%"/>
          </div>
          <!--content start-->
          <div class="content detail-content">

            <div class="swiper-container banner"
                 v-if="detailsTxte.page_config && detailsTxte.page_config.top_view == 'slideshow'">
              <div class="swiper-wrapper">
                <div class="swiper-slide bg-cover" v-for="item in detailsTxte.top_view">
                  <img :src="JSON.parse(item.img_path).h5"/>
                </div>
              </div>
              <!-- Add Pagination -->
              <div class="swiper-pagination"></div>
            </div>
            <div v-else>
              <div class="banner-video" v-if="detailsTxte.page_config && detailsTxte.page_config.top_view == 'trailer'">
                <!--视频播放-->
                <div id="Trailer" class="video_left" :uuid="detailsTxte.top_trailer.uuid" style="margin: 0 auto">
                </div>
              </div>
              <div class="dl-banner" v-else>
                <img v-if="detailsTxte.playbill" :src="detailsTxte.playbill.playbill_h5" alt=""/>
                <em class="pic-box-em pic-box-em2"><img :src="globalUrl + 'static/dist/img/off.png'" alt=""/></em>
              </div>
            </div>
            <!--download-->
            <div class="show-box">
              <div class="show-department">
                <div class="show-dl-top clearfix" @click="contactFn">
                  <h5 class="detail-hostunit">
                    <h3>{{detailsTxte.title,30| ellipsis}}</h3>
                  </h5>
                  <div class="show-logo">
                    <img v-if="detailsTxte.hostunit" :src="detailsTxte.hostunit.host_avatar" alt=""/>
                  </div>
                </div>
               <!--  <p class="clearfix" style="margin: 0;font-size: 14px;color: #999;margin-top: 10px"
                   v-if="detailsTxte.hostunit">{{detailsTxte.hostunit.channel_title}}
                  <span style="float: left;margin-right: 5px"
                        v-if="detailsTxte.hostunit && detailsTxte.hostunit.column_name">{{detailsTxte.hostunit.column_name}}</span>
                  <span style="float: left;margin-right: 5px"
                        v-if="detailsTxte.hostunit && detailsTxte.hostunit.cctv_child_name">{{detailsTxte.hostunit.cctv_child_name}}</span>
                  <span class="detail-More">
                  </span>
                </p> -->
              <!--   <div class="xians" v-if="detailsTxte.contact_info">
                  <div v-show="contact" class="show-contact" style="display:none">联系方式</div>
                  <div v-show="contact" class="show-away" style="display:none" v-if="detailsTxte.contact_info.weixin">
                    微信：{{detailsTxte.contact_info.weixin}}
                  </div>
                  <div v-show="contact" class="show-away" style="display:none" v-if="detailsTxte.contact_info.weibo">
                    微博：{{detailsTxte.contact_info.weibo}}
                  </div>
                  <div v-show="contact" class="show-away" style="display:none" v-if="detailsTxte.contact_info.qq">
                    qq：{{detailsTxte.contact_info.qq}}
                  </div>
                  <div v-show="contact" class="show-away" style="display:none" v-if="detailsTxte.contact_info.email">
                    邮箱：{{detailsTxte.contact_info.email}}
                  </div>
                  <div v-show="contact" class="show-away" style="display:none" v-if="detailsTxte.contact_info.phone">
                    手机：{{detailsTxte.contact_info.phone}}
                  </div>
                </div> -->
              </div>
            </div>
            <div v-if="ID != '100145'" class="show-box detail-time  show-dl-ldtxts">
              <div>
                <h4 style="font-size: 16px">活动时间</h4>

                <p style="font-size: 14px">{{detailsTxte.start_time|format}}开始 -
                  {{detailsTxte.end_time,detailsTxte.start_time|orderByTime|format}}</p>
              </div>
            </div>
            <!--详情介绍-->
            <div class="dl-detail">
              <div class="dl-bx" v-if="!detailsTxte.page_config || detailsTxte.page_config.about_view != 0">
                <h5 class="show-tit" v-if="detailsTxte.description">详情介绍
                </h5>

                <!-- <div :class="openOn == true?'dl-mess-box dl-mess-last':'dl-mess-box dl-mess-lasts'" style="height: auto"> -->
                <div class="dl-mess-box dl-mess-last" style="height: auto">
                  <div class="dl-mess-inner">
                    <!-- v-show="openOn"-->
                    <div class="dl-text" v-if="detailsTxte.description" v-html="detailsTxte.description">
                    </div>
                    <!--展示更多-->
                    <!-- <div class="more-display" v-show="!openOn"> -->
                    <div class="more-display">
                      <div class="dl-text 2111" v-if="detailsTxte.detail" v-html="detailsTxte.detail"></div>
                      <div class="dl-video-pic" v-if="detailsTxte.trailer_config" style="margin: 5px 0 5px -15px">
                        <!--宣传视频播放-->
                        <div v-if="detailsTxte.trailer_config.pub_uuid">
                          <div id="myFlash" class="video_left" :uuid="detailsTxte.trailer_config.pub_uuid"
                               style="margin-left: 10px">
                          </div>
                          <div class="dl-texttit" style="margin: 0">
                            <p v-if="detailsTxte.trailer_config" style="margin-bottom: 0;padding: 0">
                              {{detailsTxte.trailer_config.pub_title}}</p>
                          </div>
                        </div>
                      </div>

                      <div class="dl-text" v-if="detailsTxte.rule" v-html="detailsTxte.rule"></div>
                      <div class="dl-text" v-if="detailsTxte.feedback" v-html="detailsTxte.feedback"></div>

                      <div class="dl-text-gray" v-if="detailsTxte.slogan" v-html="detailsTxte.slogan"></div>
                      <a v-if="detailsTxte.website_url" :href="detailsTxte.website_url.url" class="dl-text-entry"><i
                        class="icon-entry" v-if="detailsTxte.website_url.text"></i>
                        {{detailsTxte.website_url.text}}
                      </a>
                    </div>
                  </div>

                </div>
                <!-- <div class="dl-mess-modal">
                  <a href="javascript:void(0);" @click="Open" :class="openOn == true?'btn-dl-up':'btn-dl-up ishow'">
                    {{openText}}
                    <i :class="openOn == true?'icon-down icon-turn':'icon-down'"></i>
                  </a>
                </div> -->


                <!--免责声明-->
                <div class="dl-detail-agree" v-if="detailsTxte.page_config&&detailsTxte.page_config.accept&&detailsTxte.page_config.accept.is_show==1">
                  <label>
                    <input type="checkbox" id="agree" v-model="agreeState">
                    <span v-on:click="agree">{{detailsTxte.page_config.accept.title}}</span>
                  </label>
                </div>

              </div>

              <div class="dl-join-box" id="pos">
                <!--系列活动-->
                <Series v-if="detailsTxte" :twoNumbers="twoNumbers" :detailsTxte="detailsTxte"></Series>
                <div v-if="detailsTxte.page_config && detailsTxte.page_config.show_count">
                  <div v-if="!(detailsTxte.page_config && detailsTxte.page_config.show_count && detailsTxte.page_config.show_count.is_show == 0)">
                    <p v-if="detailsTxte.part_num > 0">
                      <span v-if="detailsTxte.part_num" v-for="(val,i) in String(detailsTxte.part_num)">{{val}}</span>
                      人参与
                    </p>
                    <p v-else>
                      <span>0</span>
                      人参与
                    </p>
                    <p v-if="ID =='100145'"></p>
                    <p v-else-if="detailsTxte.follow_num > 0">
                      <span v-if="detailsTxte.follow_num"
                            v-for="(val,i) in String(detailsTxte.follow_num)">{{val}}</span>
                      人关注
                    </p>
                    <p v-else>
                      <span>0</span>
                      人关注
                    </p>
                  </div>
                </div>
              </div>


            </div>

            <!--activiy in progress-->
            <div class="line" v-if="progressName"></div>
            <div class="show-box" v-if="progressName">
              <h5 class="show-tit">{{progressTitle}}
                <router-link tag="a" class="show-linkmore"
                             :to="{name:'list_image',params: {id: detailsTxte.id, init:1}}">
                  更多
                </router-link>
              </h5>

              <!--info-->
              <div class="show-acty-info">{{detailsTxte.start_time}} 被加入活动候选资料库</div>

              <!-- Swiper -->
              <div class="swiper-container show-activiy-swiper">
                <div class="swiper-wrapper">
                  <div class="swiper-slide" v-for="(v,ind) in progressName">
                    <ul class="show-list-more">
                      <li v-for="(item,i) in threeNumbers" v-if="progress[ind*2+i]">
                        <a href="javascript:void(0);"
                           @click="video(progress[ind*2+i].file_type,detailsTxte.id,detailsTxte.playbill.playbill_h5,i,progress[ind*2+i].uuid)">
                          <div class="pic-box-more">
                            <img v-if="progress[ind*2+i].file_type == 1" :src="progress[ind*2+i].thumb_path" alt=""/>
                            <img v-else :src="progress[ind*2+i].file_path" alt=""/>
                            <i class="icon-time" v-if="progress[ind*2+i].time_span">{{progress[ind*2+i].time_span|formatSeconds}}</i>
                            <i class="icon-time" v-else>图片</i>
                          </div>
                        </a>

                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>

            <!--internet friend poll-->
            <!-- 网友投票 -->
            <Vote v-if="detailsTxte" :twoNumbers="twoNumbers" :detailsTxte="detailsTxte"></Vote>

            <!-- excellent work -->
            <!-- 征集作品 -->
            <Collection v-if="detailsTxte" :twoNumbers="twoNumbers" :detailsTxte="detailsTxte"
                        :globalUrl="globalUrl"></Collection>

            <!-- wonderful picture -->
            <!-- 精彩图集 -->
            <div class="line" v-if="marvellous.length>1"></div>
            <div class="show-box" v-if="marvellous.length>1">
              <router-link tag="a"
                           :to="{name:'list_image', params: {id: detailsTxte.id,init:1}}"
                           style="text-decoration: none">

                <h5 class="show-tit">{{marvellousTitle}}
                  <a href="javascript:void(0);" class="show-linkmore">
                    更多
                  </a>
                </h5>
              </router-link>

              <!-- Swiper -->
              <div class="swiper-container swiper-pic">
                <div class="swiper-wrapper">
                  <div class="swiper-slide" v-for="(item,i) in marvellous">
                    <a href="javascript:void(0);" @click="water(item)">
                      <img style="height: 120px;width: auto" :src="item.file.image_url" alt=""/>
                    </a>
                  </div>
                </div>
              </div>
            </div>

            <!--activity recommend-->
            <!--最新发布-->
            <Release v-if="detailsTxte" :twoNumbers="twoNumbers" :detailsTxte="detailsTxte"></Release>

            <div class="line" v-if="thirdParty"></div>

            <!-- 大家帮大家 -->
            <div class="detail-everybody" v-if="ID == '77066'" style="background: #f3f3f4">
              <img :src="globalUrl + 'static/dist/image/everybody.jpg'" alt=""/>
            </div>

            <!--department-->
            <div class="show-box" v-if="thirdParty">
              <div class="show-dl-download">
                <img src="" alt=""/>
              </div>
              <p class="show-dl-ldtxt show-dl-ldtxts"><span><a
                href="/paike.html">更多酷炫视频，尽在央视爱秀客户端！</a></span>
              </p>
            </div>

            <!--message-->
            <div class="dl-message">
              <div class="dl-ms-title">
                <i class="icon-message"></i>留言
              </div>
              <div class="dl-ms-edit">
                <i class="icon-edit"></i>我有话说
              </div>
              <div class="dl-ms-link">
                <div class="dl-ms" v-for="(item,ind) in leavingName">
                  <!-- 主留言 -->
                  <div class="dl-ms-head">
                    <div class="dl-head-pic">

                      <img :src="item.avatar" alt=""/>
                    </div>
                    <div class="dl-head-name">
                      {{item.author}}<span>[{{item.locale}}]</span>
                    </div>
                    <div class="dl-head-like">
                      <i class="icon-like"><em>+1</em></i>
                      <span>{{item.agree}}</span>
                      <i class="icon-ms-reply" :attr-pid="item.pid" :attr-tip="item.tid"></i>
                    </div>
                  </div>
                  <!--回复-->
                  <div class="dl-ms-chat">
                    <div class="dl-ms-tit" v-html="$options.filters.msg(item.message)">
                      <!--{{item.message | replace_em}}-->
                    </div>
                    <div class="dl-ms-time">
                      <!--  {{item.dateline|TimeName}}-->
                    </div>
                  </div>
                  <div class="dl-time">{{new Date().getTime()/1000 - item.dateline | timeToMillion}}</div>
                  <div class="dl-re-box" v-if="item.replys">
                    <div class="dl-ms-re" v-for="(reps,idx) in item.replys">
                      <span class="re-user">{{reps.author}}</span>：<span class="re-ms" v-html="$options.filters.msg(reps.message)" ></span>
                    </div>

                  </div>
                </div>
                <p class="dl-ms-more" @click="moreFn">查看更多留言</p>
              </div>
            </div>
          </div>
          <!-- content end -->
          <!-- footer -->
          <PointFooter style="margin-bottom: 50px;" v-if="detailsTxte&&detailsTxte.page_config&&detailsTxte.page_config.cctvheader&&detailsTxte.page_config.cctvheader.is_show!=0"></PointFooter>

        </div>
      </div>
      <!-- bottom-bar start -->
      <div v-if="ID=='100145'" class="detail-bottom">
          <a href="javascript:void(0)" class="dl-btn-join" style="float:left;margin-left:-7px;width:50%;"
             @click="participateIn(detailsTxte.playbill,detailsTxte.id)"><i class="icon-join"></i>{{joinWord}}</a>
          <a href="https://vod.cctv.cn/cctv/download/share/index.html" class="dl-btn-join" style="margin-right:3px;width:50%">下载客户端</a>
      </div>
      <div v-else class="detail-bottom">
        <router-link to="/MyMessage" class="dl-btn-mine" tag="a"><i class="icon-mine"></i>我的</router-link>
        <template v-if="!isSeries">
          <a href="javascript:void(0)" class="dl-btn-attack" @click="follow"><i
            :class="followOn == true?'icon-attack icon-attack-on':'icon-attack'"></i>关注</a>
          <!-- <a v-if="seriesName == 'true'" href="javascript:void(0)" class="dl-btn-join dl-btn-joinTo dl-ms-edit"><i
            class="icon-join"></i>留言</a> -->
          <!--dl-btn-active-->
          <a href="javascript:void(0)" v-bind:class="['dl-btn-join', agreeState?'':'disabled']"
             @click="participateIn(detailsTxte.playbill,detailsTxte.id)"><i class="icon-join"></i>{{joinWord}}</a>
        </template>
         <a v-else href="javascript:void(0)" class="dl-btn-attack dl-btn-attack-series" @click="follow"><i
          class="icon-attack"></i>{{followOn?'已':'' }}关注</a>
      </div>
      <div class="detail-bottom-ipx">

      </div>
      <!--bottom-bar end-->

      <!--message box-->
      <div class="detail-messagebox">
        <div class="detail-messbox-inner">
          <h5>我有话说</h5>

          <div class="dl-ms-btn"></div>
          <div class="dl-ms-wrap">
            <div class="dl-ms-inner">
              <textarea id="saytext" rows="6" placeholder="最多可输入120字" maxlength="120"></textarea>
              <i class="icon-smile emotion"></i>
            </div>
          </div>
          <a href="javascript:void(0);" class="btn-detail-edit">
            完&nbsp;&nbsp;成
          </a>
        </div>
      </div>

      <!--投票浮标按钮-->
      <router-link v-if="detailsTxte.playbill &&detailsTxte.is_vote == 1" tag="a"
                   class="btn-detail-poll  btn-detail-anim" style="z-index: 9999;display: none"
                   :to="{name:'list_vote',params: {id: detailsTxte.id,active: 1}}">
        <span></span>
        <i></i>
      </router-link>

    </div>
    <!-- Modal -->
    <!--投票  投票结束  发布留言成功-->
    <VoteAlert></VoteAlert>
  <!--   弹出框-->
    <div class="entry-modal large-info-modal modal fade" id="Alert" role="dialog" data-backdrop="static"
         aria-hidden="false">
      <div class="modal-dialog" role="document">
        <div class="modal-content" style="text-align: center">
          <div class="modal-body">
            <p class="Prompt-p">活动已结束！</p>
            <button class="buttonZ buttonDiv" data-dismiss="modal" @click="toHome">确&nbsp;&nbsp;定</button>
            
          </div>
        </div>
      </div>
    </div>
    <!--发布留言成功-->
    <div class="samll-info-modal modal fade" id="chatModal" role="dialog" aria-hidden="true">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-body">
            <div class="modal-inner">
              <i class="icon-modal"></i>

              <p class="info-mess">留言发布成功啦！</p>
            </div>
          </div>
        </div>
      </div>
    </div>


    <div class="modal-confim large-info-modal modal fade" id="login_Alert" role="dialog" aria-hidden="true"
         style="overflow: hidden">
      <div class="modal-dialog" role="document" style="margin-top: 0;width: 100%;height: 100%;">
        <div class="modal-content" style="left: -1%;top: -1%;width: 102%;height: 102%">
          <div class="modal-body">
            <LoginAler></LoginAler>
          </div>
        </div>
      </div>
    </div>

    <!--消息提示-->
    <div class="samll-info-modal modal fade" id="msg_Alert" role="dialog" aria-hidden="true">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-body">
            <div class="modal-inner">
<!--              <i class="icon-modal"></i>-->
              <p class="info-mess"></p>
            </div>
          </div>
        </div>
      </div>
    </div>


  </div>
</template>
<script>
  import footer from './template/footer.vue'
  import loginAler from './loginAler.vue'
  import voteAlert from './template/voteAlert.vue';
  import vote from './detailtmplate/vote'
  import collection from './detailtmplate/collection'
  import release from './detailtmplate/release'
  import series from './detailtmplate/series'
  import Loading from './template/loading.vue'

  export default {
    data() {
      return {
        ID: '',
        NumberName: '10', // 显示条数
        twoNumbers: 2,    // 轮播个数
        threeNumbers: 3,  // 轮播个数
        contact: false,   // 联系方式
        openOn: true,
        openText: '展开全文',
        textName: false,
        followOn: false,   // 关注
        detailsTxte: '',
        progress: '',      // 进展
        progressTitle: '', // 活动进展Title---
        progressName: '',  // 进展数量
        marvellous: '',    // 精彩图集
        marvellousTitle: '', // 精彩图集title---
        leavingName: [],  //留言
        userId: '',
        nickname: '',
        poll: true,
        seriesName: 'false',// 是否留言
        leavingPage: 1,
        globalUrl: API.GlobalUrl,
        participate: true,
        aTitle: '成功',
        thirdParty: false,
        timer: null,
        joinWord: '我要参与',
        isSeries: false,
        activeStyle: '',
        myflashLoaded: false,
        agreeState:false

      }
    },
    filters: {
      msg: function (str) {
        str = str.replace(/\</g, '&lt;');
        str = str.replace(/\>/g, '&gt;');
        str = str.replace(/\n/g, '<br/>');
        str = str.replace(/\[em_([0-9]*)\]/g, '<img src="' + API.GlobalUrl + 'static/dist/arclist/$1.gif" border="0" />');
        return str;
      }
    },
    methods: {
      toHome:function() {
        this.$router.push({path: '/home'})
      },
      detail(type, id, route, customized, subUrl) {// 跳转详情页面
        if (customized == 2 || customized == 1) {
          this.$router.push({name: 'Detail', params: {id: id}});
        } else {
          if (type == 2) {
            this.$router.push({name: 'Notice', params: {id: id}});
          } else if (type == 3) {
            this.$router.push({name: 'list_vote', params: {id: id, active: 1}});
          } else {
            this.$router.push({name: 'Detail', params: {id: id}});
          }
        }

      },
      video(type, id, route, int, uuid) {
        if (type == 1) {
          this.$router.push({name: 'Video', params: {id: id, uuid: uuid}});
        } else {
          this.$router.push({name: 'list_image', params: {id: id, int: int}});
        }
      },
      water(item) {
        this.data = new Date();
        this.$router.push({name: 'VideoName', params: {id: item.activity_id, uuid: item.file_id, type: item.file_type}})
      },
      //登录
      determine() {
        $('#detailAlert').modal('hide');
      },
      contactFn() {
        var that = this
        that.contact = !that.contact;
        if (that.contact) {
          $('.show-department').find('.detail-More').addClass('detail-MoreDeg');
        } else {
          $('.show-department').find('.detail-More').removeClass('detail-MoreDeg');
        }
      },
      // 关注
      fetchData() {
        window.location.reload()
      },
      follow() {  // 点击关注按钮
        var that = this;
        if (!that.loginFn()) {
          if(!window.isThisClient('cbox')){
            $('#login_Alert').modal('show');
            return false;
          }
        }
        if (that.followOn == false) {
          var add = {
            item_id: that.$route.params.id,
            type: '0'
          };
          that.$http.get(API.AddActivityFollow, {params: add})
            .then(function (res) {
              //console.log(res)
              if (res.code == 0) {
                that.followOn = true;
              } else if (res.code = '1001') {
                //$('#login_Alert').modal('show');
                //that.$router.push({name: 'login_Quick'})
              }

            })
        } else if (that.followOn == true) {
          var delFollo = {
            item_id: that.$route.params.id,
            type: '0'
          };
          that.$http.get(API.DelActivityFollow, {params: delFollo})
            .then(function (res) {
              if (res.code == 0) {
                that.followOn = false;
              } else if (res.code = '1001') {
                //$('#login_Alert').modal('show');
              }
            })
        }
      },
      //我要参与
      participateIn(router, id) {
        var that = this;
        if(!that.agreeState){
          return;
        }
        var joinBtn = that.detailsTxte.page_config.joinBtn;
        if (that.loginFn()) {
          var routerName = '';
          if (router.playbill_small_h5) {
            routerName = router.playbill_small_h5
          } else {
            routerName = router.playbill;
          }
          //判断参与和投票
          if(joinBtn && joinBtn.style == 1){//参与
            this.$http.get(API.IsJoin, {params: {activity_id: id}})
              .then(function (res) {
                console.log(res);
                if (res.code == 0) {
                  if (res.data.isJoin == 0) {
                    that.$router.push({name: 'Notice', params: {id: id}})
                  } else if(res.data.child_sign&&res.data.child_sign.is_show=="1"){
                    // 只能参与一个子活动
                    $("#msg_Alert").find(".info-mess").html(res.data.child_sign.title);
                    $("#msg_Alert").modal();
                  }else{
                    // that.$router.push({name: 'myActivity_MyParticipate', params: {id: id}});
                    that.$router.push({name: 'Revise', params: {id: id,form_id:0}});
                    return false;
                  }
                } else {
                  $('#login_Alert').modal('show');
                }
            })
          }else if(joinBtn.style == 2){//投票
            that.$router.push({name:'list_vote',params:{id:id,active:1}})
          }
          // if ($('.dl-time').text().trim() != '活动已结束') {
            // 判读是否参加过


          // } else {
          //   alert('你要参与的活动已结束')
          // }
        } else {
          if(!window.isThisClient('cbox')){
            $('#login_Alert').modal('show');
          }
        
        }
      },
      // 操作按钮事件
      Open() {  // 点击“查看全文”按钮
        var that = this;
        this.openOn = !this.openOn;
        if (this.openOn == true) {
          this.openText = '展开全文';
        } else {
          this.openText = '收起全文';
          if (that.detailsTxte.trailer_config && that.detailsTxte.trailer_config.pub_uuid && !that.myflashLoaded) {
            // setTimeout(function () {
              that.myflashLoaded = true;
              that.textName = true;
              // var len = $('.video_left').length;
              var uuid = that.detailsTxte.trailer_config.pub_uuid;
              var W = $('#myFlash').width();
              var H = W / 1.78;
              that.VideoPlay(uuid, W, H, 'myFlash')
            // }, 500)
          }
        }
      },

      leavingMessage(ind) { // 留言查看更多dl-log-list
        if (!$('.dl-ms-more').eq(ind).hasClass('dl-ms-more-over')) {
          $('.dl-ms-more').eq(ind).parents('.dl-ms-log').css({'height': '100%'});
          $('.dl-ms-more').eq(ind).addClass('dl-ms-more-over');
        } else {
          $('.dl-ms-more').eq(ind).removeClass('dl-ms-more-over');
        }
      },
      moreFn() {
        var page = ++this.leavingPage;
        this.leavingFn(page)
      },
      leavingFn(page) { // 留言
        var that = this;
        var Leaving = {
          app: 'xiyou',
          itemid: 'ishow_' + that.$route.params.id,
          // itemtype: '0',
          prepage: 10,
          avatar: 1,
          page: page,
          reply: 10
        };
        //xiyou
        $.getJSON('//common.newcomment.cntv.cn/data/list?jsonp_callback=?', Leaving, function (res) {
          //console.log(res)
          if (res.code == 0) {
            var content = res.data.content;
            var reply = res.data.reply;
            for (var m = 0; m < content.length; m++) {
              // (function(m){

                that.leavingName.push(content[m]);
                var pid = content[m].pid;
                var tip = content[m].tip;
                if(reply[pid]){
                  that.leavingName[m].replys = reply[pid].reverse();
                }
                //回复列表
                // var Reply = {
                //   app: 'xiyou',
                //   itemid: 'ishow_' + that.$route.params.id,
                //   replyid: pid
                // };
                // $.getJSON('http://common.newcomment.cntv.cn/comment/list?jsonp_callback=?', Reply, function (res) {
                //   if(res.code == 0){
                //     that.leavingName[m].replys = res.content;
                //   }
                // });
              // }(m));
            }
            if (content.length === 0 || that.leavingName.length == res.data.total) {
              $('.dl-ms-more').hide();
            }
          }
        });
      },
      interval(startTime){//活动倒计时
        var that = this;
        var deta,detaTime;
        startTime = startTime.replace(/-/g,'/');
        var $btn = $('.dl-btn-join')
        var start  =  + new Date(startTime);
        this.timer = setInterval(()=>{
          deta = start - new Date();
          if(deta > 0){
            detaTime = + new Date(deta);
            setLeft(detaTime,$btn);
            console.log('timer')
          }else{
            clearInterval(that.timer);
            $btn.removeClass('dl-btn-active').html('<i class="icon-join"></i>' + that.joinWord);

          }
        },1000)

        function setLeft(leftTime, $btn){
          var d = Math.floor(leftTime/1000/60/60/24);
          var h = Math.floor(leftTime/1000/60/60%24);
          var m = Math.floor(leftTime/1000/60%60);
          var s = Math.floor(leftTime/1000%60);
          var str = geneStr({d:d,h:h,m:m,s:s});
          $btn.html(str)
        }
        function geneStr(obj){
          var str = '';
          if(obj.d > 0){
            str += pre0(obj.d) + '天'
          }
          if(obj.d > 0 || obj.h >0){
            str += pre0(obj.h) + '时'
          }
          if(obj.d > 0 || obj.h > 0 || obj.m > 0){
            str += pre0(obj.m) + '分'
          }
          if(obj.d > 0 || obj.h > 0 || obj.m >0 || obj.s > 0){
            str += pre0(obj.s) + '秒'
          }
          return str;
        }
        function pre0(t){
         return  t < 10 ? '0'+ t : t;
        }

      },

      agree:function(){
        console.log("agree");
      }
     
    },
    components: {   //渲染页面
      PointFooter: footer,
      LoginAler: loginAler,
      VoteAlert: voteAlert,
      Vote: vote,
      Collection: collection,
      Release: release,
      Series: series,
      Loading: Loading
    },
    // created() {
    //   var self = this;
    //   // self.fetchData();
    // },
    watch: {
      '$route.params.id': 'fetchData'
    },
    created: function () {
      var that = this;
      var id = this.$route.params.id;
      that.ID = id;
      // 判断是否pc
      if (that.IsPC()) {
        window.location.href = API.IsPcName
      }
      // 判断安卓机去掉动画
      that.isAndroid();
      if (!that.ID) {
        this.$router.push({name: 'Home'})
      }
      $('html,body').css({scrollTop: '0px'});
      //是否登录
      that.userId = that.getCookie('userSeqId') || '';
      if (that.userId) {
        var headPortrait = '//my.cntv.cn/intf/napi/api.php?cb=?&client=xiyou&method=user.getNickNameAndFace&userid=' + that.userId;
        //console.log(headPortrait)
        $.getJSON(headPortrait, function (res) {
          that.nickname = res.content.nickname;
        });
      }
      //是否关注
      // if (that.loginFn()) {
      that.$http.get(API.IsFollowByUserid, {params: {item_id: id}})
        .then(function (res) {
          if (res.code == '0') {
            if (res.data == 1) {
              that.followOn = true
            }
          }
        });
      // }

      //活动详情
      if(window.isThisClient('cbox')){
         that.cboxregisterhandler();
      }
      $(document).unbind("scroll");
      this.$http.get(API.GetActivitieById, {params: {id: id}})
        .then(function (res) {
          if (res.code == 0) {

            that.detailsTxte = res.data;
            console.log("detailsTxte:",that.detailsTxte);
            var sUserAgent = navigator.userAgent.toLowerCase();
            var bIsCbox = sUserAgent.match(/cntv_app_client_cbox_mobile/i) == "cntv_app_client_cbox_mobile";
            var cBox = sUserAgent.match(/cntvcbox/i) == "cntvcbox";

            //活动下线
            if(!res.data.id){
              that.$router.replace({name: 'NotFound'});
            }
             
            if (bIsCbox || cBox) {
              $('.detail-header').hide();
            }

            if (that.ID == '100072') {
              $('.detail-header').hide();
            }

            if (!res.data || res.data.length == 0) {
              that.$router.push({name: 'HomeIndex'})
            }

            if (that.detailsTxte.playbill_vertical) {
              setTimeout(function () {
                $('.detai-pic').hide();
              }, 1800)
            }

            that.$nextTick(function () {
              setTimeout(function(){
                $('#loading').hide();
              },1000)
              //是否 系列活动
               if(that.detailsTxte.type == 1){
                that.isSeries = true;
                //$('.dl-btn-join').addClass('dl-btn-active');
              }else{
                var astyle = that.detailsTxte.page_config.joinBtn.style;
                if(astyle == 2){
                  that.detailsTxte.end_time = that.detailsTxte.vote_end_time;
                  that.detailsTxte.start_time = that.detailsTxte.vote_start_time;
                }
                //是否进行中
                var dataTime = new Date(that.detailsTxte.end_time.replace(/-/g,'/')).getTime() / 1 /*+ 86400000 */- new Date().getTime();
                var startTime = new Date(that.detailsTxte.start_time.replace(/-/g,'/')).getTime() / 1 - new Date().getTime();
                // startTime = new Date('2018-11-24 16:15:00').getTime() / 1 - new Date().getTime();
                that.joinWord =  that.detailsTxte.page_config.joinBtn && that.detailsTxte.page_config.joinBtn.title || '我要参与';


                if(that.ID == '84203'){
                  // $('.dl-btn-join').html('<i class="icon-join"></i>我要报名')
                  that.joinWord = '我要报名'
                }
                if (dataTime > 0) {
                  $('.pic-box-em').hide()
                  //我要参加按钮

                } else {
                  $('.dl-btn-join').addClass('dl-btn-active')//.html('<i class="icon-join"></i>已结束');
                  $('.pic-box-em').show()
                  that.joinWord = '已结束'
                  $('#Alert').find('.Prompt-p').html('活动已结束！');
                  $('#Alert').modal('show');

                }
                if(startTime > 0) {
                  $('.pic-box-em').hide()
                  $('.dl-btn-join').addClass('dl-btn-active');
                  //$('.dl-btn-join').html('<i class="icon-join"></i>即将开始');
                  that.interval(that.detailsTxte.start_time);
                  // that.interval('2018-1-24');

                }
              }


              // 征集活动
              /*  if (that.detailsTxte.type != 1) {
                  // 是有报名表单项
                  this.$http.get(API.GetActivityFormFields, {params: {activity_id: id}})
                    .then(function (res) {
                      if (res.code == 0) {
                        if (res.data.length == 0) {
                          $('.dl-btn-join').addClass('dl-btn-active');
                          that.participate = false;
                        }
                      }
                    });
                }*/
              // 背景颜色
              // console.log("detail");
              if (that.detailsTxte.background_img) {
                document.styleSheets[0].addRule('.detail::before', 'background: url("' + that.detailsTxte.background_img + '") no-repeat');
                document.styleSheets[0].insertRule('.detail::before { background: url("' + that.detailsTxte.background_img + '") no-repeat}', 0);
              } else {//
              // console.log("else");
                document.styleSheets[0].addRule('.detail::before', 'background: url(../dist/img/bzbg.jpg) no-repeat');
                document.styleSheets[0].insertRule('.detail::before { background: url(../dist/img/bzbg.jpg) no-repeat}', 0);
              }
              // 是否展示更多
              if ($('.dl-text').height() > 100) {
                that.textName = true
              }
              // dl-mess-modal
              // 宣传片
              if (that.detailsTxte.detail == '' && that.detailsTxte.rule == '' && that.detailsTxte.feedback == '') {
                if (that.detailsTxte.trailer_config && that.detailsTxte.trailer_config.pub_title == '' && that.detailsTxte.trailer_config.pub_uuid == '') {
                  $('.dl-mess-modal').hide();
                  $('.detail-content').find('.dl-mess-last').css('margin-bottom', 0)
                } else {
                  $('.dl-mess-modal').show();
                }
              } else {
                $('.dl-mess-modal').show();
              }

              if (that.detailsTxte.trailer_config && that.detailsTxte.trailer_config.pub_uuid ) {
                that.myflashLoaded = true;
                that.textName = true;
                var uuid = that.detailsTxte.trailer_config.pub_uuid;
                var W = $('#myFlash').width();
                var H = W / 1.78;
                that.VideoPlay(uuid, W, H, 'myFlash')
              }



              // 宽高比例
              var banWimg = $('.dl-banner').width();
              var banHimg = Math.ceil($('.dl-banner').width() / 2);
              $('.dl-banner img').css({width: banWimg, height: banHimg, visibility: 'visible'});


              var contact_info = that.detailsTxte.contact_info;
              // 判断联系方式模块是否显示
              if (contact_info) {
                if (contact_info.qq || contact_info.email || contact_info.phone || contact_info.weibo || contact_info.weixin) {

                } else {
                  $('.detail-More').hide();
                  $('.xians').hide()
                }
              } else {
                $('.detail-More').hide();
                $('.xians').hide()
              }

              // 判断是否是定制
              if (that.detailsTxte.type == 2) {
                window.location.href = that.detailsTxte.sub_url
              }

              var pageConfig = that.detailsTxte.page_config


              // 判断是否显示
              if (pageConfig) {

                // 免责声明
                if(pageConfig.accept&&pageConfig.accept.is_show==1){
                  that.agreeState=false;
                }else{
                  that.agreeState=true;
                }

                if (pageConfig.cbox == 0) {
                  $('.detail-header').hide();
                }
                //logo轮播
                if (pageConfig.top_view == 'slideshow') {
                  var swiper1 = new Swiper('.banner', {
                    pagination: '.swiper-pagination',
                    paginationType: 'custom',
                    paginationCustomRender: function (swiper, current, total) {
                      var lineWidth = (100 / total) - 0.4;
                      var str = '';
                      for (var i = 0; i < total; i++) {
                        if (i == current - 1) {
                          str += '<span class="spanline-class spanline-active" style="width:' + lineWidth + '%"></span>';
                        } else {
                          str += '<span class="spanline-class" style="width:' + lineWidth + '%"></span>';
                        }
                      }
                      return str;
                    },
                    paginationClickable: true,
                    autoplayDisableOnInteraction: false,
                    autoplay: 4000,
                    loop: true
                  });
                }
                //头部 宣传片
                if (pageConfig.top_view == 'trailer' && that.detailsTxte.top_trailer.uuid) {
                  var ZW = $('.banner-video').width();
                  var uuid = $('#Trailer').attr('uuid'),
                    FH = ZW / 16 * 9,
                    W = ZW * 0.75,
                    H = W / 1.78;
                  var dlH = ZW * 0.666;

                  $('.banner-video').css({
                    'height': dlH,
                    'padding-top': (dlH - H) / 2 + 16 + 'px',
                    'background': 'url(' + that.detailsTxte.top_trailer.img_path + ') no-repeat',
                  })
                  that.VideoPlay(uuid, W, H, 'Trailer')
                }

                //活动进展
                if (pageConfig.march && pageConfig.march.is_show == 1) {
                  that.progressTitle = pageConfig.march.title;
                  //活动进展
                  var getRelatedVideo = {
                    activity_id: id,
                    page: 1,
                    pagesize: 9
                  };
                  // 活动进展
                  that.$http.get(API.GetRelatedVideo, {params: getRelatedVideo})
                    .then(function (res) {
                      if (res.code == 0) {
                        that.progressName = Math.floor(res.data.length / 2);
                        that.progress = res.data;
                        /* console.log(res)*/
                        // 图片比例
                        that.PictureRatio();
                        that.$nextTick(function () {
                          that.PictureRatio();
                          var swiperActivity = new Swiper('.show-activiy-swiper', {
                            loop: true
                          });
                        })
                      } else {
                        console.log('活动进展-请求数据信息出错')
                      }
                    });
                }

                // 图片展示
                if (pageConfig.img && pageConfig.img.is_show == 1) {
                  // 精彩图集
                  that.marvellousTitle = pageConfig.img.title;
                  // 精彩图集
                  that.$http.get(API.FileRelatedVideo, {
                    params: {
                      page: '1',
                      pagesize: '10',
                      type: '2',
                      activity_id: id,
                      version: 2
                    }
                  })
                    .then(function (res) {
                      //   console.log(res)
                      if (res.code == 0) {
                        that.marvellous = res.data;
                        that.$nextTick(function () {
                          var spNum = $('.swiper-pic').find('img').length;
                          var swiperPic = new Swiper('.swiper-pic', {
                            slidesPerView: 'auto',
                            spaceBetween: 6,
                            loop: true,
                            loopedSlides: spNum
                          });
                        })
                      } else {
                        console.log('精彩图集-请求数据信息出错')
                      }
                    });
                }
                //是否显示评论模块
                if (pageConfig.comment == 1) {
                  //评论渲染
                  // $('.dl-message').show();
                  $('.dl-message').hide();
                  //留言
                  that.leavingFn(1)
                } else {
                  $('.dl-message').hide();
                  $('.dl-btn-joinTo').addClass('dl-btn-active')
                }

                //小程序屏蔽评论
                function ready() {
                    if(window.__wxjs_environment === 'miniprogram'){
                      $('.dl-message').hide();
                      $('.dl-btn-joinTo').hide();
                    }
                  }
                  if (!window.WeixinJSBridge || !WeixinJSBridge.invoke) {
                    document.addEventListener('WeixinJSBridgeReady', ready, false)
                  } else {
                   ready()
                  }



              }
              // var script = document.createElement('script');
              // var head = document.getElementsByTagName('head')[0];
              // script.src = 'http://static.qr.cntv.cn/weixin/static/js/jssdk.js';
              //分享微信
              var title = '',
                desc = '',
                img = '';
              var obj = that.detailsTxte.share_config;
              var typeObj = '';
              if (obj instanceof Array) {
                if (obj.length > 0) {
                  typeObj = true
                } else {
                  typeObj = false
                }
              } else {
                if (that.detailsTxte.share_config) {
                  typeObj = true
                } else {
                  typeObj = false
                }
              }
              if (typeObj) {
                var activity = that.detailsTxte.share_config.activity;
                if (activity && activity.share_title) {
                  title = activity.share_title
                } else {
                  title = that.detailsTxte.title;
                }
                if (activity && activity.share_contents) {
                  desc = activity.share_contents
                } else {
                  desc = $('.dl-text').text();
                }
                if (activity && activity.share_pic) {
                  img = activity.share_pic
                } else {
                  if (that.detailsTxte.playbill && that.detailsTxte.playbill.playbill_h5) {
                    img = that.detailsTxte.playbill.playbill_h5
                  }
                }
              } else {
                title = that.detailsTxte.title;
                desc = $('.dl-text').text();
                if (that.detailsTxte.playbill && that.detailsTxte.playbill.playbill_h5) {
                  img = that.detailsTxte.playbill.playbill_h5
                } else {
                  img = that.detailsTxte.playbill.playbill
                }
              }
              document.title = title;
              let metas = $('head').children('meta');
              if (metas[1]) {
                metas[1].content = desc;
              }
              console.log(img);
              if (img == '') {
                img = that.detailsTxte.playbill.playbill_h5 || that.detailsTxte.playbill.playbill
              }
              console.log(img);
              var dataName = {
                title: title,
                desc: that.removeTAG(desc, 110),
                imgAddress: img,
                Retain: '',//保留
                url: window.location.href
              };
              that.weixinShare(dataName);
              if(window.isThisClient('cbox')){
                // window.ShareCbox({title:title, contents: that.removeTAG(desc, 110),pic: img,url: window.location.href});
                that.cboxShare(img,window.location.href,title,that.removeTAG(desc, 110));
              }

            });
            //活动是否结束
            if ($('.dl-time').text().trim() == '活动已结束') {
              $('.dl-but-join').addClass('dl-btn-off')
            }

            //埋码统计
            var stcode =  that.detailsTxte.code;
            if(stcode){
              stcode = JSON.parse(stcode);
            }
            var q = (window.goldlog_queue || (window.goldlog_queue = []));
            q.push({
              action: 'goldlog.sendPV',
              arguments: [
                // 必填的配置项
                {
                    is_auto: false
                  },
                // 可选的自定义参数
                {
                  ch_id: stcode &&stcode.code && stcode.code.channel_code || 'EPGC1386744804340101',
                  col_id: stcode && stcode.code && stcode.code.program_code || 'EPGM1387361853673102'
              }]
            });

          } else {
            that.$router.push({name: 'HomeIndex'})
          }
        });
      //是否点击活动
      if (this.id == '') {
        this.$router.push({name: 'Home'})
      }
    },

    mounted: function () {
      // 操作DOM
      // 返回事件
      var that = this;
      $('body').attr('style', '');

      function getCookie(name) {
        var arr = document.cookie.split('; ');
        for (var i = 0; i < arr.length; i++) {
          var arr2 = arr[i].split('=');
          if (arr2[0] == name) {
            return arr2[1];
          }
        }
        return '';
      }

      var that = this,
        id = this.$route.params.id;
      setTimeout(function () {
        // 表情
        // poster的高度
        // 留言点赞
        $('.dl-message').on('click', '.dl-head-like', function () {
          if ($(this).hasClass('dl-head-like-over')) {
            $(this).find('em').removeClass('em-animt');
            $(this).removeClass('dl-head-like-over').find('span').html(Number($(this).find('span').html()) - 1);
          } else {
            $(this).find('em').addClass('em-animt');
            $(this).addClass('dl-head-like-over').find('span').html(Number($(this).find('span').html()) + 1);
          }
        });

        //关闭留言框面板
        $('.dl-ms-btn').on('click', function () {
          $('#saytext').val('');
          $('.detail-messagebox').css({'top': '120%'});
        });

        // 打开留言面板
        $('.detail').on('click', '.dl-ms-edit', function () {
          if (that.loginFn()) {
            console.log('判断是否登录-已登录')
          } else {
            $('#login_Alert').modal('show');
            // that.$router.push({name: 'login_Quick'})
            return false;
          }
          $('.emotion').qqFace({
            id: 'facebox',
            assign: 'saytext',
            path: API.GlobalUrl + '/static/dist/arclist/' //表情存放的路径
          });
          $('#saytext').val('');
          $('.detail-messagebox').css({'top': '0'});
          $('.btn-detail-edit').removeClass('btn-detail-reply')
        });
        var PID = '',
          TID = '';
        //回复留言 打开留言面板
        $('.dl-message').on('click', '.icon-ms-reply', function (e) {
          e.stopPropagation();
          if (that.loginFn()) {
            console.log('判断是否登录-已登录')
          } else {
            $('#login_Alert').modal('show');
            return false;
          }
          $('.emotion').qqFace({
            id: 'facebox',
            assign: 'saytext',
            path: API.GlobalUrl + '/static/dist/arclist/' // 表情存放的路径
          });
          PID = $(this).attr('attr-pid');
          TID = $(this).attr('attr-tip');
          $('#saytext').val('');
          $('.detail-messagebox').css({'top': '0'});
          $('.btn-detail-edit').addClass('btn-detail-reply')
        });
        var intervaLock;
        $('.btn-detail-edit').on('click', function () {
          if ($('#saytext').val() != '') {
            //回复留言
            if ($('.btn-detail-edit').hasClass('btn-detail-reply')) {
              var Leaving = {
                app: 'xiyou',
                itemid: 'ishow_' + that.$route.params.id,
                replyid: PID, // pid
                tid: TID,
                author: that.nickname, // 用户名
                authorid: that.userId, // 用户id
                message: $('#saytext').val()
              };
              //console.log(Leaving)
              $.ajax({
                type: 'post',
                url: '//newcomment.cntv.cn/comment/post',
                data: Leaving,
                dataType: 'jsonp',
                xhrFields: {
                  withCredentials: true
                },
                jsonp: 'jsonp_callback',
                success: function (res) {
                  // console.log(res)
                  if (res.code == 0) {
                    $('.detail-messagebox').css({'top': '120%'});
                    $('#chatModal').modal('show');
                    intervaLock = setTimeout(function () {
                      $('#chatModal').modal('hide')
                    }, 2000);
                  } else if (res.code == '20927') {
                    var userSeqId = getCookie('userSeqId');
                    var urlHref = window.location.href;
                    var url = 'http://reg.cctv.com/authenicateAction/mobile/bind.html?service=' + urlHref + '&iid=' + id + '&formFlag=3&userSeqId=' + userSeqId + '&flag=H5';
                    window.location.href = url
                  }
                }
              })
              //发布留言
            } else {
              var Leaving = {
                app: 'xiyou',
                itemid: 'ishow_' + that.$route.params.id,
                authorid: that.userId,
                author: that.nickname,
                message: $('#saytext').val()
              };
              //  console.log(Leaving)
              $.ajax({
                type: 'post',
                url: '//newcomment.cctv.com/comment/post',
                data: Leaving,
                dataType: 'jsonp',
                xhrFields: {
                  withCredentials: true
                },
                crossDomain: true,
                jsonp: 'jsonp_callback',
                success: function (res) {
                  //console.log(res)
                  if (res.code == 0) {
                    $('.detail-messagebox').css({'top': '120%'});
                    $('#chatModal').modal('show');
                    intervaLock = setTimeout(function () {
                      $('#chatModal').modal('hide')
                    }, 2000);
                  } else if (res.code == '20927') {
                    var userSeqId = getCookie('userSeqId');
                    var url = 'http://reg.cctv.com/authenicateAction/mobile/bind.html?service=' + API.UrlName + '/h5/index&iid=' + id + '&formFlag=3&userSeqId=' + userSeqId + '&flag=H5';
                    window.location.href = url
                  }
                },
                error: function () {
                  // alert('请求出错！');
                }
              });
            }
          }
        });
        $('.detail').on('click', '.dbroadcast', function () {
          var item = JSON.parse($(this).attr('attr-item'));
          var type = $(this).attr('attr-type');
          that.detail(item.url, item.id, item.img_path, item.type, item.sub_url)
        })

        if (window.isThisClient('cbox') && that.ID == '100071') {
          $('#pos').hide();
        }
        // 安卓 ios判断
        var u = navigator.userAgent;
        var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1; // android终端
        var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); // ios终端

        if (isAndroid) {
          //安卓
          $('.show-dl-download img').attr('src', 'http://static.qr.cntv.cn/ishow/images/wx-android.jpg');
        }
        if (isiOS) {
          //ios
          $('.show-dl-download img').attr('src', 'http://static.qr.cntv.cn/ishow/images/wx-ios.jpg');
        }
        // isIPhoneX()

        function isIPhoneX(fn) {
          var u = navigator.userAgent;
          var isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); // ios终端
          if (isIOS) {
            if (screen.height == 812 && screen.width == 375) {
              $('.detail-bottom').css('bottom', '20px')
              $('.detail-bottom-ipx').show();
            } else {
              //不是iphoneX
              $('.detail-bottom-ipx').hide();
            }
          }
        }

        // 视频尺寸
        $('#my-video').width($('.dl-video-pic').width());
        $('#my-video').height($('.dl-video-pic').width() / 16 * 9);
        that.PictureRatio();
      }, 400)

    }
  }
</script>

<style>
  .detail-bottom .dl-btn-off {
    background: #ccc;
    border: 1px solid #ccc;
  }

  .dl-message .dl-ms-chat .dl-ms-tit img {
    height: 24px;
    width: 24px;
  }

  .detail-bottom-ipx {
    display: none;
    position: fixed;
    left: 0;
    bottom: 0;
    width: 100%;
    z-index: 999;
    height: 20px;
    background: #1c1b20;
  }
</style>



// WEBPACK FOOTER //
// src/components/detail.vue